import Big from 'big.js';

import {
  DerivativesOpenedPositionProjection,
  DerivativesOrderProjection,
} from 'common/api/autogenerated/trading-gateway';

import { isBuy } from 'views/derivatives/orders/utils';

export const calculateTakeProfitPnl = (
  position: Pick<
    DerivativesOpenedPositionProjection & DerivativesOrderProjection,
    'quantity' | 'tradingPairCode' | 'settlementCurrency' | 'entryPrice' | 'takeProfitPrice'
  > &
    Pick<DerivativesOrderProjection | DerivativesOpenedPositionProjection, 'side'>,
) => {
  const size = Number(position.quantity);
  const takeProfit = position.takeProfitPrice;
  const [baseCurrency] = String(position.tradingPairCode).split('-');

  if (!Number(takeProfit) || !position.entryPrice || !size) return 0;

  const isBuyPosition = isBuy(position.side);
  const isSellPosition = !isBuyPosition;

  const isLinearPosition = baseCurrency !== position.settlementCurrency;
  const isInversedPosition = !isLinearPosition;

  if (isBuyPosition) {
    // for SettlementCurrency=QuoteCurrency
    if (isLinearPosition) {
      return new Big(Number(takeProfit)).minus(position.entryPrice).times(size).toNumber();
    }
    // for SettlementCurrency=BaseCurrency
    if (isInversedPosition) {
      return new Big(size)
        .times(Number(takeProfit) - position.entryPrice)
        .div(Number(takeProfit))
        .toNumber();
    }
  }
  if (isSellPosition) {
    // for SettlementCurrency=QuoteCurrency
    if (isLinearPosition) {
      return new Big(position.entryPrice).minus(Number(takeProfit)).times(size).toNumber();
    }
    // for SettlementCurrency=BaseCurrency
    if (isInversedPosition) {
      return new Big(size)
        .times(position.entryPrice - Number(takeProfit))
        .div(Number(takeProfit))
        .toNumber();
    }
  }

  return 0;
};

export const calculateStopLossPnl = (
  position: Pick<
    DerivativesOpenedPositionProjection & DerivativesOrderProjection,
    'quantity' | 'tradingPairCode' | 'settlementCurrency' | 'entryPrice' | 'stopLossPrice'
  > &
    Pick<DerivativesOrderProjection | DerivativesOpenedPositionProjection, 'side'>,
) => {
  const size = Number(position.quantity);
  const stopLoss = position.stopLossPrice;
  const [baseCurrency] = String(position.tradingPairCode).split('-');

  if (!Number(stopLoss) || !position.entryPrice || !size) return 0;

  const isBuyPosition = isBuy(position.side);
  const isSellPosition = !isBuyPosition;

  const isLinearPosition = baseCurrency !== position.settlementCurrency;
  const isInversedPosition = !isLinearPosition;

  if (isBuyPosition) {
    // for SettlementCurrency=QuoteCurrency
    if (isLinearPosition) {
      return new Big(Number(stopLoss)).minus(position.entryPrice).times(size).toNumber();
    }
    // for SettlementCurrency=BaseCurrency
    if (isInversedPosition) {
      return new Big(size)
        .times(Number(stopLoss) - position.entryPrice)
        .div(Number(stopLoss))
        .toNumber();
    }
  }
  if (isSellPosition) {
    // for SettlementCurrency=QuoteCurrency
    if (isLinearPosition) {
      return new Big(position.entryPrice).minus(Number(stopLoss)).times(size).toNumber();
    }
    // for SettlementCurrency=BaseCurrency
    if (isInversedPosition) {
      return new Big(size)
        .times(position.entryPrice - Number(stopLoss))
        .div(Number(stopLoss))
        .toNumber();
    }
  }

  return 0;
};
